import { AgoraRTCProvider as BaseAgoraRTCProvider } from "agora-rtc-react";
import { IAgoraRTCClient } from "agora-rtc-react";
import * as React from "react";

export type AgoraRTCProviderProps = {
  client: IAgoraRTCClient;
  children: React.ReactNode;
};

export const AgoraRTCProvider: React.FC<AgoraRTCProviderProps> = props => {
  return <BaseAgoraRTCProvider client={props.client}>{props.children}</BaseAgoraRTCProvider>;
};
